import { render, staticRenderFns } from "./RegistrationSuccess.vue?vue&type=template&id=cd279d18&scoped=true&"
import script from "./RegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./RegistrationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSuccess.vue?vue&type=style&index=0&id=cd279d18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd279d18",
  null
  
)

export default component.exports